import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import * as Yup from "yup";
import {
  COMPANY_FETCH_URL, ESTATE_FETCH_URL, REGION_FETCH_URL, ZONE_FETCH_URL,

} from "../../../configs/constants";
import Table from "components/Table";
import Filter from "@Components/Filter";
import { IconButton } from "@material-ui/core";
import ExcelLogo from "assets/img/excel_icon.svg";
import PdfLogo from "assets/img/pdf_icon.svg";
import { useNotifyContext } from "components/Notify";



let model = [
  { id: "employee_id", label: "Worker ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "supervisor", label: "Supervisor", type: "string" },
  { id: "worker_group", label: "Worker Group", type: "string" },
  { id: "date", label: "Date", type: "date" },
  { id: "clock_in_time", label: "Today Clock In Time", type: "time" },
  { id: "clock_out_time", label: "Today Clock Out Time", type: "time" },
  { id: "status", label: "Status", type: "string" },
  { id: "remarks", label: "Attendance Type", type: "string" },

];



const HqViewReport = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableZone, setDisableZone] = useState(true);
  const setNotify = useNotifyContext();


  const details = useLocation();
  const URLS = {
    ATTENDANCE_LOG: "report/attendance",
  };
  const today = new Date();
  today.setDate(today.getDate() - 1);
  const options = { timeZone: 'Asia/Kuala_Lumpur' };
  let date = today.toLocaleDateString('en-GB', options);
  date = date.split('/').reverse().join('-');

  const getFormDate = (e) => {
    setSelectedFormDate(e);
  };
  const getToDate = (e) => {
    setSelectedToDate(e);
  };

  const filterFields = [

    {
      type: "datepicker",
      label: "From Date",
      name: "from",
      maxDate: selectedtoDate,
      getValue: getFormDate,
      required: true

    },
    {
      type: "datepicker",
      label: "To Date",
      name: "to",
      minDate: selectedFormDate,
      getValue: getToDate,
      required: true

    },



    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
      required: true,


    },



    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled: disableZone,
      optionsDependsOn: "company",
      required: true,
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      disabled: disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
      required: true,

    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      disabled: disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),
      required: true,
      optionsDependsOn: "region",
    },







  ];



  const validationSchema = Yup.object({
    from: Yup.date().required("Date is required").nullable().typeError("Invalid From Last Login Date"),
    to: Yup.date().required("Date is required").nullable().typeError("Invalid To Last Login Date"),
    company: Yup.string().required("Company is required").nullable().typeError("Company is required"),
    zone: Yup.string().required("Zone is required").nullable().typeError("Zone is required"),
    region: Yup.string().required("Region is required").nullable().typeError("Region is required"),
    estate: Yup.string().required("Estate is required").nullable().typeError("Estate is required"),

  });
  const filterInitialValues = {
    from: date,
    to: date,

  };
  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }

  };

  const getZoneValues = (e, setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }

  };
  const getRegionValues = (e, setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }

  };

  const getEstateValues = (e, setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }

  };
  let filters = {};
  if ("searchParams" in details) {
    if (details.searchParams.from.dateForAPI) {
      filters["from"] = details.searchParams.from.dateForAPI;
    }
    if (details.searchParams.to.dateForAPI) {
      filters["to"] = details.searchParams.to.dateForAPI;
    }

  }

  const onFilterRequest = (values) => {
    const fromDate = new Date(values.from);
    const toDate = new Date(values.to);

    if (fromDate.getMonth() !== toDate.getMonth()) {
      setNotify({
        isOpen: true,
        message: "Date should be from the same month.",
        type: "error",
      });
      return;
    }

    const diffInDays = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

    

    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }


  return (
    <>
      <Filter filterFields={filterFields} initialValues={filterInitialValues} onSubmit={onFilterRequest} validationSchema={validationSchema} noSearchButton 
        generateReport={true}    onClear={clearFilter}
        />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >


      </div>
      {filtersApplied ? (

        <Table
          proxyURL={URLS.ATTENDANCE_LOG}
          model={model}
          filterValues={filterValues}
          noFilter
          excelExport={{ fileName: "EstateReport" }}
          pdfExport={{ fileName: "EstateReport" }}
          noAddButton
          disableLabelDisplayedRows = {true}
          tableBodyDisable={true}
          paginationDisable={true}
        />
      ) : (

        <Table
          proxyURL={null}
          model={model}
          filterValues={filterValues}
          disablePdfExport={true}
          disableExcelExport={true}
          noFilter
          noAddButton
          disableLabelDisplayedRows = {true}
          tableBodyDisable={true}
          paginationDisable={true}
        />
      )}



    </>
  );
};
export default HqViewReport;
